module.exports = __webpack_public_path__ + "media/images/sp/components/specials/special_offer/arrow-658dd591356a1635508cc1365cb3a8c1.svg";